import { EpisodeOfCare } from '@/types/episodeOfCare';
import { ProgramQualification } from '@/types/person';

const hideDisqualificationsAndRejections = (
  programQualification: ProgramQualification | null | undefined,
  episodeOfCare: EpisodeOfCare | null
): boolean => {
  return (
    !programQualification ||
    programQualification?.status === 'active' ||
    (!episodeOfCare?.graduation_reason &&
      !episodeOfCare?.discharge_reasons.length &&
      !programQualification?.disqualification_reasons.length &&
      !programQualification?.intake_rejection_reasons.length)
  );
};

export default hideDisqualificationsAndRejections;
